import CarouselImage from "./CarouseImage"; // Adjust the path as necessary
import OverlayContent from "./OverlayContent"; // Adjust the path as necessary
import { CarouselV2 } from "pepsico-ds";
import "./HomePageCarousal.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { Skeleton } from "@mui/material";
import {
  setCarousalImage,
} from "../../slices/imageSlice";
const HomePageCarousal = ({ slots: slotsProp = [] }) => {
  const isDarkTheme = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const { carosalImages } = useSelector(
    (store) => store.images
  );
  
  useEffect(() => {
    if (slotsProp && slotsProp.length > 0) {
      dispatch(setCarousalImage(slotsProp));
    }
  }, [slotsProp, dispatch]);

  const displayData = (slotsProp && slotsProp.length > 0) ? slotsProp : carosalImages;
  
  return (
    <div className="relative w-full  h-[420px]">
      {displayData?.length === 0 && (
        <Skeleton
          data-testid="skeleton-loader"
          variant="rectangular"
          width="100%"
          height="100%"
          // style={{ borderRadius: `${borderRadius}px`, position: "absolute" }}
        />
      )}

      <CarouselV2
        autoPlay
        autoPlayInterval={5000}
        style={{
          padding: 0,
          width: "100%",
        }}
        itemData={displayData?.map((item) => (
          <div key={item?.id} className="relative">
            <CarouselImage src={item?.cdnUrl} />
            <div className="z-10 w-full max-w-[493px] absolute inset-0 flex items-center justify-center px-6 md:px-0 md:left-[151px] md:items-start md:justify-start md:top-[75px]">
              <OverlayContent style={{ pointerEvents: "auto" }} data={item} />
            </div>
          </div>
        ))}
        isDark={isDarkTheme}
      />
    </div>
  );
};

export default HomePageCarousal;
